import FileUploader from './FileUploader';
import type { FileDetails } from './FileUploader.types';

export type { FileDetails };
export default FileUploader;
